import { EmptyState } from "./components-v2/EmptyState";
import { Button } from "./components-v2/Button";
import { FullScreenLayout } from "./components-v2/FullScreenLayout";
import { ReactElement } from "react";
import { VBox } from "./components-v2/Box";

export function ErrorPage({ backUrl, header }: { backUrl: string; header?: ReactElement }) {
  return (
    <FullScreenLayout
      pageHeader={header}
      centerPanel={
        <VBox grow="golden" justifyContent="center">
          <EmptyState
            illustration={"bug-droid"}
            title={{ key: "error.page.title" }}
            description={{ key: "error.page.description" }}
            actions={
              <Button
                variant={"primary"}
                label={{ key: "error.page.backToPortfolio" }}
                onClick={() => (window.location.href = backUrl)}
              />
            }
          />
        </VBox>
      }
    />
  );
}
